import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  private url:string = `${environment.apiCoreUpload}/upload-file/`;
  private urlfile:string = `${environment.apiCoreUpload}/binary-upload-file/`;

  constructor( private http: HttpClient ) { }

  uploadFile(fd) {
    return this.http.post(this.url,fd, { headers: { "x-api-key": environment.xApiKeyUpload } }).toPromise()
  }

  uploadFileBinary(fd) {
    return this.http.post(this.urlfile,fd, { headers: { "x-api-key": environment.xApiKeyUpload } }).toPromise()
  }
}
